var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68 2.97L6.8 0.85C7 0.66 7 0.34 6.8 0.15C6.6 -0.04 6.29 -0.05 6.09 0.15L3.97 2.27L1.85 0.15C1.65 -0.05 1.34 -0.05 1.14 0.15C0.939998 0.35 0.939998 0.66 1.14 0.86L3.26 2.98L1.15 5.1C0.949998 5.3 0.949998 5.61 1.15 5.81C1.35 6.01 1.66 6.01 1.86 5.81L3.98 3.69L6.1 5.8C6.29 6 6.61 6 6.8 5.8C6.99 5.6 7 5.29 6.8 5.1L4.68 2.97Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSmall);
export default __webpack_public_path__ + "static/media/delete-small.2330e6f19b395e2a90726ae15bdec796.svg";
export { ForwardRef as ReactComponent };